import {Component, OnInit} from '@angular/core';
import Chart from 'chart.js';
import {AdminDashboardService} from '../../service/admin-dashboard.service';
import swal from 'sweetalert2';
import {InventoryService} from '../../service/inventory.service';


@Component({
  selector: 'app-admin-dashboard',
  moduleId: module.id,
  templateUrl: './admin-dashboard.component.html'
})
export class AdminDashboardComponent implements OnInit {
  public canvas: any;
  public ctx;
  public chartColor;
  public chartEmail;
  public chartHours;
  public dailyPerformance;

  public pendingRequestCount: number;
  public rejectRequestCount: number;
  public issuedRequestCount: number;
  public totalRequestCount: number;
  public result: number;

  public dataEntryRequestCount: number;
  public bioMetricRequestCount: number;
  public shoRequestCount: number;
  public examinerRequestCount: number;
  public dgRequestCount: number;
  public printingRequestCount: number;
  public qaRequestCount: number;
  public scanRequestCount: number;
  public dispatchRequestCount: number;
  public weekWiseCount: any;
  public monthWisePendingCount: any;
  public monthWiseRejectedCount: any;
  public monthWiseIssuedCount: any;


  public weekOneCount: number;
  public weekTwoCount: number;
  public weekThreeCount: number;
  public weekFourCount: number;

  public januaryPendingCount: number;
  public februaryPendingCount: number;
  public marchPendingCount: number;
  public aprilPendingCount: number;
  public mayPendingCount: number;
  public junePendingCount: number;
  public julyPendingCount: number;
  public augustPendingCount: number;
  public septemberPendingCount: number;
  public octoberPendingCount: number;
  public novemberPendingCount: number;
  public decemberPendingCount: number;

  public januaryIssuedCount: number;
  public februaryIssuedCount: number;
  public marchIssuedCount: number;
  public aprilIssuedCount: number;
  public mayIssuedCount: number;
  public juneIssuedCount: number;
  public julyIssuedCount: number;
  public augustIssuedCount: number;
  public septemberIssuedCount: number;
  public octoberIssuedCount: number;
  public novemberIssuedCount: number;
  public decemberIssuedCount: number;

  public januaryRejectedCount: number;
  public februaryRejectedCount: number;
  public marchRejectedCount: number;
  public aprilRejectedCount: number;
  public mayRejectedCount: number;
  public juneRejectedCount: number;
  public julyRejectedCount: number;
  public augustRejectedCount: number;
  public septemberRejectedCount: number;
  public octoberRejectedCount: number;
  public novemberRejectedCount: number;
  public decemberRejectedCount: number;

  public OpeningQty: number;
  public TotalAddedQty: number;
  public AvailableStockQty: number;
  public TotalReturnedQty: number;
  public TotalIssuedQty: number;
  public TotalCancelQty: number;


  constructor(private adminDashBoardService: AdminDashboardService, public inventory_service: InventoryService) {
  }

  async ngOnInit() {
    this.getPendingRequestCount();
    this.getRejectRequestCount();
    this.getIssuedRequestCount();
    this.getTotalRequestCount();
    this.getMonthWiseSubmittedCount();
    this.getLastInventoryDetails();
    this.weekWiseCount = await this.getWeekWiseRequestCount();
    await this.getMonthWisePendingCount();
    await this.getMonthWiseRejectedCount();
    await this.getMonthWiseIssuedCount();

    this.dataEntryRequestCount = await this.getDataEntryRequestCount();
    this.bioMetricRequestCount = await this.getBiometricRequestCount();
    this.shoRequestCount = await this.getSHORequestCount();
    this.examinerRequestCount = await this.getExaminerRequestCount();
    this.dgRequestCount = await this.getDGRequestCount();
    this.printingRequestCount = await this.getPrintingRequestCount();
    this.qaRequestCount = await this.getQARequestCount();
    this.scanRequestCount = await this.getScanRequestCount();
    this.dispatchRequestCount = await this.getDispatchRequestCount();
    this.chartColor = '#FFFFFF';


    this.initDailyPerformanceBarChart();


    this.canvas = document.getElementById('chartHours');
    this.ctx = this.canvas.getContext('2d');

    this.chartHours = new Chart(this.ctx, {
      type: 'line',

      data: {
        labels: ['1 Week', '2 Week', '3 Week', '4 Week'],
        datasets: [{
          label: '1 Week',
          borderColor: '#6bd098',
          backgroundColor: '#6bd098',
          pointRadius: 1,
          pointHoverRadius: 0,
          borderWidth: 3,
          data: [this.weekOneCount, this.weekTwoCount, this.weekThreeCount, this.weekFourCount]
        },
          {
            label: '2 Week',
            borderColor: '#f17e5d',
            backgroundColor: '#f17e5d',
            pointRadius: 1,
            pointHoverRadius: 0,
            borderWidth: 3,
            data: [this.weekOneCount, this.weekTwoCount, this.weekThreeCount, this.weekFourCount]
          },
          {
            label: '3 Week',
            borderColor: '#686ffc',
            backgroundColor: '#6874fc',
            pointRadius: 1,
            pointHoverRadius: 0,
            borderWidth: 3,
            data: [this.weekOneCount, this.weekTwoCount, this.weekThreeCount, this.weekFourCount]
          },
          {
            label: '4 Week',
            borderColor: '#cc0c80',
            backgroundColor: '#cc0c80',
            pointRadius: 1,
            pointHoverRadius: 0,
            borderWidth: 3,
            data: [this.weekOneCount, this.weekTwoCount, this.weekThreeCount, this.weekFourCount]
          }
        ]
      },
      options: {
        legend: {
          display: true
        },

        tooltips: {
          enabled: true,
        },

        scales: {
          yAxes: [{

            ticks: {
              fontColor: '#9f9f9f',
              beginAtZero: false,
              maxTicksLimit: 5,
              //padding: 20
            },
            gridLines: {
              drawBorder: false,
              zeroLineColor: '#ccc',
              color: 'rgba(255,255,255,0.05)'
            }

          }],

          xAxes: [{
            // barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(255,255,255,0.1)',
              zeroLineColor: 'transparent',
              display: false,
            },
            ticks: {
              padding: 20,
              fontColor: '#9f9f9f'
            }
          }]
        },
      }
    });


    this.canvas = document.getElementById('chartEmail');
    this.ctx = this.canvas.getContext('2d');
    this.chartEmail = new Chart(this.ctx, {
      type: 'pie',
      data: {
        labels: ['Opening', 'Added', 'Returned', 'Issued', 'Cancelled', 'Stock'],
        datasets: [{
          pointRadius: 0,
          pointHoverRadius: 0,
          backgroundColor: [
            'rgba(255,99,132,1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)',
          ],
          borderWidth: 0,
          data: [this.OpeningQty, this.TotalAddedQty, this.TotalReturnedQty, this.TotalIssuedQty, this.TotalCancelQty, this.AvailableStockQty]
        }]
      },

      options: {

        legend: {
          display: true
        },


        tooltips: {
          enabled: true
        },

        scales: {
          yAxes: [{

            ticks: {
              display: false
            },
            gridLines: {
              drawBorder: false,
              zeroLineColor: 'transparent',
              color: 'rgba(255,255,255,0.05)'
            }

          }],

          xAxes: [{
            // barPercentage: 1.6,
            gridLines: {
              drawBorder: false,
              color: 'rgba(255,255,255,0.1)',
              zeroLineColor: 'transparent'
            },
            ticks: {
              display: false,
            }
          }]
        },
      }
    });

    var speedCanvas = document.getElementById('speedChart') as HTMLCanvasElement;

    var dataFirst = {
      data: [this.januaryPendingCount, this.februaryPendingCount, this.marchPendingCount, this.aprilPendingCount, this.mayPendingCount, this.junePendingCount, this.julyPendingCount, this.augustPendingCount, this.septemberPendingCount, this.octoberPendingCount, this.novemberPendingCount, this.decemberPendingCount],
      label: 'Pending',
      fill: false,
      borderColor: '#fbc658',
      backgroundColor: 'transparent',
      pointBorderColor: '#fbc658',
      pointRadius: 4,
      pointHoverRadius: 4,
      pointBorderWidth: 8,
    };

    var dataSecond = {
      data: [this.januaryRejectedCount, this.februaryRejectedCount, this.marchRejectedCount, this.aprilRejectedCount, this.mayRejectedCount, this.juneRejectedCount, this.julyRejectedCount, this.augustRejectedCount, this.septemberRejectedCount, this.octoberRejectedCount, this.novemberRejectedCount, this.decemberRejectedCount],
      label: 'Rejected',
      fill: false,
      borderColor: '#51CACF',
      backgroundColor: 'transparent',
      pointBorderColor: '#51CACF',
      pointRadius: 4,
      pointHoverRadius: 4,
      pointBorderWidth: 8
    };

    var dataThird = {
      data: [this.januaryIssuedCount, this.februaryIssuedCount, this.marchIssuedCount, this.aprilIssuedCount, this.mayIssuedCount, this.juneIssuedCount, this.julyIssuedCount, this.augustIssuedCount, this.septemberIssuedCount, this.octoberIssuedCount, this.novemberIssuedCount, this.decemberIssuedCount],
      label: 'Issued',
      fill: false,
      borderColor: '#ef8157',
      backgroundColor: 'transparent',
      pointBorderColor: '#ef8157',
      pointRadius: 4,
      pointHoverRadius: 4,
      pointBorderWidth: 8
    };

    var speedData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      datasets: [dataFirst, dataSecond, dataThird]
    };

    var chartOptions = {
      legend: {
        display: false,
        position: 'top'
      }
    };

    var lineChart = new Chart(speedCanvas, {
      type: 'line',
      // hover: false,
      data: speedData,
      // options: chartOptions
    });
  }

  getPendingRequestCount() {
    this.adminDashBoardService.getPendingRequestCount().subscribe(
      (result: number) => {
        this.pendingRequestCount = result;
      }
    )
  }

  getRejectRequestCount() {
    this.adminDashBoardService.getRejectRequestCount().subscribe(
      (result: number) => {
        this.rejectRequestCount = result;
      }
    )
  }

  getIssuedRequestCount() {
    this.adminDashBoardService.getIssuedRequestCount().subscribe(
      (result: number) => {
        this.issuedRequestCount = result;
      }
    )
  }

  getTotalRequestCount() {
    this.adminDashBoardService.getTotalRequestCount().subscribe(
      (result: number) => {
        this.totalRequestCount = result;
      }
    )
  }

  async getDataEntryRequestCount(): Promise<number> {
    await this.adminDashBoardService.getDataEntryRequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  async getBiometricRequestCount(): Promise<number> {
    await this.adminDashBoardService.getBiometricRequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  async getSHORequestCount() {
    await this.adminDashBoardService.getSHORequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  async getExaminerRequestCount() {
    await this.adminDashBoardService.getExaminerRequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  async getDGRequestCount() {
    await this.adminDashBoardService.getDGRequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  async getPrintingRequestCount() {
    await this.adminDashBoardService.getPrintingRequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  async getQARequestCount() {
    await this.adminDashBoardService.getQARequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  async getScanRequestCount(): Promise<number> {
    await this.adminDashBoardService.getScanRequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  async getDispatchRequestCount() {
    await this.adminDashBoardService.getDispatchRequestCount().toPromise().then(result => {
      this.result = parseInt(result.toString());
    });
    return this.result;
  }

  getMonthWiseSubmittedCount() {
    this.adminDashBoardService.getMonthWiseSubmittedCount().subscribe(
      (result: any) => {

      })
  }

  async getWeekWiseRequestCount() {
    await this.adminDashBoardService.getWeekWiseRequestCount().toPromise().then(result => {
      // this.result =parseInt(result.toString());
      this.weekWiseCount = result;
      let dataAvailableWeekCount = Object.keys(this.weekWiseCount).length;
      if (dataAvailableWeekCount === 1) {
        let weekOne_Count = this.weekWiseCount[0];
        this.weekOneCount = weekOne_Count[1];
        this.weekTwoCount = 0;
        this.weekThreeCount = 0;
        this.weekFourCount = 0;
      } else if (dataAvailableWeekCount === 2) {
        let weekOne_Count = this.weekWiseCount[0];
        let weekTwo_Count = this.weekWiseCount[1];

        this.weekOneCount = weekOne_Count[1];
        this.weekTwoCount = weekTwo_Count[1];
        this.weekThreeCount = 0;
        this.weekFourCount = 0;

      } else if (dataAvailableWeekCount === 3) {
        let weekOne_Count = this.weekWiseCount[0];
        let weekTwo_Count = this.weekWiseCount[1];
        let weekThree_Count = this.weekWiseCount[2];

        this.weekOneCount = weekOne_Count[1];
        this.weekTwoCount = weekTwo_Count[1];
        this.weekThreeCount = weekThree_Count[1];
        this.weekFourCount = 0;

      } else if (dataAvailableWeekCount === 4) {
        let weekOne_Count = this.weekWiseCount[0];
        let weekTwo_Count = this.weekWiseCount[1];
        let weekThree_Count = this.weekWiseCount[2];
        let weekFour_Count = this.weekWiseCount[3];

        this.weekOneCount = weekOne_Count[1];
        this.weekTwoCount = weekTwo_Count[1];
        this.weekThreeCount = weekThree_Count[1];
        this.weekFourCount = weekFour_Count[1];
      } else {
        this.weekOneCount = 0;
        this.weekTwoCount = 0;
        this.weekThreeCount = 0;
        this.weekFourCount = 0;
      }
    });
    return this.result;
  }

  async getMonthWisePendingCount() {
    await this.adminDashBoardService.getMonthWisePendingCount().toPromise().then(result => {
      this.monthWisePendingCount = result;
      let availableDataCount = Object.keys(this.monthWisePendingCount).length;
      for (let i = 0; i < availableDataCount; i++) {
        let data = this.monthWisePendingCount[i];
        if (data[0] === 1) {
          this.januaryPendingCount = data[1];
        } else if (data[0] === 2) {
          this.februaryPendingCount = data[1];
        } else if (data[0] === 3) {
          this.marchPendingCount = data[1];
        } else if (data[0] === 4) {
          this.aprilPendingCount = data[1];
        } else if (data[0] === 5) {
          this.mayPendingCount = data[1];
        } else if (data[0] === 6) {
          this.junePendingCount = data[1];
        } else if (data[0] === 7) {
          this.julyPendingCount = data[1];
        } else if (data[0] === 8) {
          this.augustPendingCount = data[1];
        } else if (data[0] === 9) {
          this.septemberPendingCount = data[1];
        } else if (data[0] === 10) {
          this.octoberPendingCount = data[1];
        } else if (data[0] === 11) {
          this.novemberPendingCount = data[1];
        } else if (data[0] === 12) {
          this.decemberPendingCount = data[1];
        }
      }
    });

  }

  async getMonthWiseRejectedCount() {
    await this.adminDashBoardService.getMonthWiseRejectedCount().toPromise().then(result => {
      this.monthWiseRejectedCount = result;
      let availableDataCount = Object.keys(this.monthWiseRejectedCount).length;
      for (let i = 0; i < availableDataCount; i++) {
        let data = this.monthWiseRejectedCount[i];
        if (data[0] === 1) {
          this.januaryRejectedCount = data[1];
        } else if (data[0] === 2) {
          this.februaryRejectedCount = data[1];
        } else if (data[0] === 3) {
          this.marchRejectedCount = data[1];
        } else if (data[0] === 4) {
          this.aprilRejectedCount = data[1];
        } else if (data[0] === 5) {
          this.mayRejectedCount = data[1];
        } else if (data[0] === 6) {
          this.juneRejectedCount = data[1];
        } else if (data[0] === 7) {
          this.julyRejectedCount = data[1];
        } else if (data[0] === 8) {
          this.augustRejectedCount = data[1];
        } else if (data[0] === 9) {
          this.septemberRejectedCount = data[1];
        } else if (data[0] === 10) {
          this.octoberRejectedCount = data[1];
        } else if (data[0] === 11) {
          this.novemberRejectedCount = data[1];
        } else if (data[0] === 12) {
          this.decemberRejectedCount = data[1];
        }
      }
    });

  }

  async getMonthWiseIssuedCount() {
    await this.adminDashBoardService.getMonthWiseIssuedCount().toPromise().then(result => {
      this.monthWiseIssuedCount = result;
      let availableDataCount = Object.keys(this.monthWiseIssuedCount).length;
      for (let i = 0; i < availableDataCount; i++) {
        let data = this.monthWiseIssuedCount[i];
        if (data[0] === 1) {
          this.januaryIssuedCount = data[1];
        } else if (data[0] === 2) {
          this.februaryIssuedCount = data[1];
        } else if (data[0] === 3) {
          this.marchIssuedCount = data[1];
        } else if (data[0] === 4) {
          this.aprilIssuedCount = data[1];
        } else if (data[0] === 5) {
          this.mayIssuedCount = data[1];
        } else if (data[0] === 6) {
          this.juneIssuedCount = data[1];
        } else if (data[0] === 7) {
          this.julyIssuedCount = data[1];
        } else if (data[0] === 8) {
          this.augustIssuedCount = data[1];
        } else if (data[0] === 9) {
          this.septemberIssuedCount = data[1];
        } else if (data[0] === 10) {
          this.octoberIssuedCount = data[1];
        } else if (data[0] === 11) {
          this.novemberIssuedCount = data[1];
        } else if (data[0] === 12) {
          this.decemberIssuedCount = data[1];
        }
      }
    });

  }


  initDailyPerformanceBarChart() {
    this.canvas = document.getElementById('barChart');
    this.ctx = this.canvas.getContext('2d');

    this.dailyPerformance = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: ['Data Entry', 'Bio Metric', 'SHO', 'Examiner', 'DG', 'Printing', 'QA', 'Scan', 'Dispatch'],
        datasets: [{
          data: [
            this.dataEntryRequestCount,
            this.bioMetricRequestCount,
            this.shoRequestCount,
            this.examinerRequestCount,
            this.dgRequestCount,
            this.printingRequestCount,
            this.qaRequestCount,
            this.scanRequestCount,
            this.dispatchRequestCount],
          // data: data,
          label: 'Request Count',
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 0, 0, 0.2)',
            'rgba(153, 145, 255, 0.2)',
            'rgba(153, 0, 255, 0.2)',
          ],
          borderColor: [
            'rgba(255,99,132,1)',
            'rgba(54, 162, 235, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(255, 159, 64, 1)',
            'rgba(255, 0, 0, 1)',
            'rgba(153, 145, 255, 1)',
            'rgba(153, 0, 255, 1)',
          ],
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }

  getLastInventoryDetails() {
    this.inventory_service.getLastInventory().subscribe(
      (data: any) => {


        this.OpeningQty = data.openingQty;
        this.TotalAddedQty = data.totalAddedQty;
        this.AvailableStockQty = data.availableStockQty;


        this.getCardsCount();

      });
  }

  getCardsCount() {
    this.inventory_service.getCarCountByStatus().subscribe(
      (data: any) => {
        // console.log(data,"data");
        this.TotalReturnedQty = data.Returned;
        this.TotalIssuedQty = data.Issued;
        this.TotalCancelQty = data.Cancel;
      });
  }

}


